/**
 * Bộ hình vẽ cho nhãn trạng thái của ô bàn và ô mang về.
 *
 * Mỗi trạng thái một hình, và cùng một hình thì ở đâu cũng nói cùng một chuyện: hình người
 * là "đang có khách", ly nước là "đồ xong rồi", đồng hồ là "chuyện của thời gian", cây bút là
 * "chưa ghi món nào". Nhờ vậy người bán lướt qua ba chục ô mà không phải đọc chữ — nhãn chỉ
 * cao 11px, ở khoảng cách đứng bán thì chữ ấy là một vệt mờ.
 *
 * Vẽ bằng nét chứ không dán emoji: emoji mang sẵn màu riêng, mà mấy cái nhãn này đổi nền
 * theo trạng thái nên hình phải ăn theo màu chữ của nhãn.
 */

const stroke = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
}

const Mark = ({ d, className }: { d: string; className?: string }) => (
  <svg
    viewBox="0 0 24 24"
    className={className ?? 'state-glyph'}
    aria-hidden="true"
    focusable="false"
  >
    <path d={d} {...stroke} />
  </svg>
)

/** Đang có khách. */
export const PersonMark = ({ className }: { className?: string }) => (
  <Mark
    className={className}
    d="M12 11.4a3.6 3.6 0 1 0 0-7.2 3.6 3.6 0 0 0 0 7.2zM4.6 20c0-3.5 3.3-5.8 7.4-5.8s7.4 2.3 7.4 5.8"
  />
)

/** Chuyện của thời gian: ngồi lâu, hoặc đang chờ tới lượt. */
export const ClockMark = ({ className }: { className?: string }) => (
  <Mark className={className} d="M12 3.6a8.4 8.4 0 1 0 0 16.8 8.4 8.4 0 0 0 0-16.8zM12 7.4V12l3.2 1.9" />
)

/** Đồ đã làm xong: đã bưng ra bàn, hoặc đang đứng đợi khách tới lấy. */
export const CupMark = ({ className }: { className?: string }) => (
  <svg
    viewBox="0 0 24 24"
    className={className ?? 'state-glyph'}
    aria-hidden="true"
    focusable="false"
  >
    <path d="M5.2 7.6h13.6" {...stroke} />
    <path
      d="M6.7 7.6 8 19.5a1.9 1.9 0 0 0 1.9 1.7h4.2a1.9 1.9 0 0 0 1.9-1.7L17.3 7.6"
      {...stroke}
    />
    <path d="M13.4 3.2 12 7.6" {...stroke} />
  </svg>
)

/** Chưa ghi món nào. */
export const PencilMark = ({ className }: { className?: string }) => (
  <Mark className={className} d="M4.5 19.5h4L19.4 8.6a2.2 2.2 0 0 0-3.1-3.1L5.4 16.4z" />
)
